/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Centro amicizia",
      "Trova nuovi amici con l'app Bumble For Friends | Bumble",
      "Scarica da App Store",
      "Disponibile su Google Play",
      "Uno spazio dedicato alle nuove amicizie",
      "Scopri persone nella tua zona che cercano legami sinceri.",
      "Trova amici per ogni momento della tua vita",
      "Da poco in città? In cerca di un nuovo inizio? Un nuovo gruppo di amici ti aspetta!",
      "Un posto sicuro per tutti",
      "Ti diamo il benvenuto in uno spazio all'insegna del rispetto, dove si può essere sé stessi.",
      "Scarica l'app",
      "Incontra persone che condividono i tuoi interessi!",
      "Trova un nuovo gruppo di amici con Plans su Bumble For Friends",
      "Hai ricevuto un invito a Plans",
      "Plans è una nuova funzione di Bumble For Friends in cui puoi creare e unirti a gruppi per incontrare nuovi amici in zona",
      "Preferenze cookie",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "giorni"
            ],
            "singular": [
                  "giorno"
            ]
      },
      "hour": {
            "plural": [
                  "ore"
            ],
            "singular": [
                  "ora"
            ]
      },
      "minute": {
            "plural": [
                  "minuti"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "mesi"
            ],
            "singular": [
                  "mese"
            ]
      },
      "second": {
            "plural": [
                  "secondi"
            ],
            "singular": [
                  "secondo"
            ]
      },
      "year": {
            "plural": [
                  "anni"
            ],
            "singular": [
                  "anno"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
